import "./App.css";
import Home from "./Home";
import Img from "./utils/Img";

function App() {
	return (
		<div className="App select-none tracking-[2px] overscroll-none">
			<Home event="homepage" />
			{/* 手機橫向提醒 */}
			<div className="fixed top-0 left-0 screen-setting bg-black z-[999] justify-center items-center hidden landscapePhone:flex pointer-events-auto">
				<div className=" w-[60%] aspect-[1/0.53] text-[20px] flex  justify-center items-center border-[3px] border-white p-[30px] rounded-[30px]">
					<div className="w-[calc(100%-210px)] mr-[25px]">
						<Img
							src="../media/devicetip.png"
							alt="橫幅手機提示"
							className="w-full h-full object-contain"
						/>
					</div>
					<div className="text-white  w-[140px] ">
						<div>
							請以<span className=" text-phRotateOrange-100">直式</span>
						</div>
						<div>繼續瀏覽網頁</div>
					</div>
				</div>
			</div>
		</div>
	);
}

export default App;
